import { Audit } from '@empathybroker/tsclient-play/dist/models/audit';
import { List } from '@empathybroker/tsclient-play/dist/models/list';

import { AuditState, MutationClass } from '../../../models';

export class SetDataMutation implements MutationClass {

  public static execute(state: AuditState, data: List<Audit>): void {
    state.data = data;
  }

}
